<template>
  <v-dialog v-model="deleteDialog" persistent max-width="460px">
    <v-card class="no-select">
      <v-layout row class="error white--text">
        <h3 class="text-uppercase px-3 pt-4" style="letter-spacing:2px">
          {{ $t('Delete Confirmation') }}
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="grey lighten-3">
        <v-flex xs12></v-flex>
        <v-layout row>
          <v-flex>
            <v-icon class="error--text" style="font-size:90px">warning</v-icon>
          </v-flex>
          <v-divider vertical class="transparent mx-2" />
          <v-flex>
            <h3 class="error--text">
              {{ $t('Are you sure you want to DELETE?') }}
            </h3>
            <p class="pt-3">
              {{
                $t('This action is permanent and CANNOT be undone, are you sure you want to proceed with the deletion.')
              }}
            </p>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3">
        <v-layout justify-space-between>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
          <v-btn color="error" @click="$emit('confirm')" :loading="btnDeleteLoading">
            {{ $t("Yes I'm sure, delete") }}
            <v-icon :right="!$vuetify.rtl" :left="$vuetify.rtl">delete_forever</v-icon>
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirm-deletion',

  props: {
    deleteDialog: { type: Boolean, required: true },
    btnDeleteLoading: { type: Boolean, required: false }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.deleteDialog) {
        // console.log('ESC button pressed from the delete modal')
        this.$emit('hidemodal')
      }
    })
  }
}
</script>
